import React, { createContext, useContext, useState, useCallback } from 'react';

import PropTypes from 'prop-types';

const FilterPanelContext = createContext({});

const usePackagesSearchFilter = () => useContext(FilterPanelContext);

const PackagesSearchFilterProvider = ({ children }) => {
  const [panelSearch, setPanelSearch] = useState('');
  const [panelFilters, setInternalPanelFilters] = useState({});

  const setPanelFilters = useCallback((arg) => {
    if (typeof arg === 'function') {
      setInternalPanelFilters(arg);
    } else {
      setInternalPanelFilters((prev) => ({ ...prev, ...arg }));
    }
  }, []);

  return (
    <FilterPanelContext.Provider
      value={{
        panelSearch,
        setPanelSearch,
        panelFilters,
        setPanelFilters,
      }}
    >
      {children}
    </FilterPanelContext.Provider>
  );
};

PackagesSearchFilterProvider.propTypes = {
  children: PropTypes.node,
};

export { usePackagesSearchFilter, PackagesSearchFilterProvider as default };
